import React from 'react';
import { Box, Grid, Typography, Paper, Avatar } from '@mui/material';
import CountUp from 'react-countup';
import { Fade } from 'react-awesome-reveal';

// ✅ Import icons
import SchoolIcon from '@mui/icons-material/School';
import CodeIcon from '@mui/icons-material/Code';
import WorkIcon from '@mui/icons-material/Work';
import GroupsIcon from '@mui/icons-material/Groups';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

const stats = [
  {
    label: 'Students Trained Online',
    value: 1500,
    suffix: '+',
    icon: <SchoolIcon fontSize="large" />,
  },
  {
    label: 'Students Trained in MERN Stack',
    value: 150,
    suffix: '+',
    icon: <CodeIcon fontSize="large" />,
  },
  {
    label: 'Students Hired @2-3 LPA',
    value: 25,
    suffix: '',
    icon: <WorkIcon fontSize="large" />,
  },
  {
    label: 'Workshop Attendees at SIMATS',
    value: 400,
    suffix: '+',
    icon: <GroupsIcon fontSize="large" />,
  },
  {
    label: 'Learners via Free Courses',
    value: 2000,
    suffix: '+',
    icon: <EmojiEventsIcon fontSize="large" />,
  },
];

function StatsSection() {
  return (
    <Box
      id="achievements"
      sx={{
        py: 10,
        background: 'radial-gradient(circle at top left, #0c1e3c, #1a2a4f)',
        color: '#ffffff',
        textAlign: 'center',
      }}
    >
      {/* 🌟 Gradient Heading */}
      <Typography
        variant="h4"
        sx={{
          mb: 6,
          fontWeight: 'bold',
          fontFamily: 'Poppins, sans-serif',
          background: 'linear-gradient(to right, #ffcb05, #ffe873)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
        }}
      >
        SPARK AI EDUTECH ON FIRE 
      </Typography>

      {/* 📊 Stats Cards */}
      <Grid
        container
        spacing={4}
        justifyContent="center"
        alignItems="center"
        sx={{ px: { xs: 2, sm: 6 } }}
      >
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Fade triggerOnce direction="up" delay={index * 150}>
              <Paper
                elevation={6}
                sx={{
                  p: 4,
                  borderRadius: 4,
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  backdropFilter: 'blur(10px)',
                  textAlign: 'center',
                  transition: 'transform 0.3s ease, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0px 12px 30px rgba(0,0,0,0.2)',
                  },
                }}
              >
                {/* 🟡 Icon Avatar */}
                <Avatar
                  sx={{
                    bgcolor: '#ffcb05',
                    color: '#0c1e3c',
                    width: 60,
                    height: 60,
                    margin: '0 auto',
                    mb: 2,
                  }}
                >
                  {stat.icon}
                </Avatar>

                {/* 🔢 Animated Number */}
                <Typography
                  variant="h3"
                  sx={{
                    color: '#ffcb05',
                    fontWeight: 'bold',
                    fontFamily: 'Poppins, sans-serif',
                    mb: 1,
                  }}
                >
                  <CountUp end={stat.value} duration={2.5} suffix={stat.suffix} />
                </Typography>

                {/* 🏷 Label */}
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: '1.05rem',
                    fontFamily: 'Poppins, sans-serif',
                    color: '#e0e0e0',
                  }}
                >
                  {stat.label}
                </Typography>
              </Paper>
            </Fade>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default StatsSection;
